const host = "https://api.app.mydogcare.com/";
export default {
  domain: host,
  apiBase: `${host}api/v1/`,
  baseName: "/",
  language: "sv",
  key: "AIzaSyAH4MXZnuxqvc_Al90nRcQklxwv7nUK1k4",
  orderConfirmUrl: "http://app.mydogcare.com/order-confirm?order_id={checkout.order.id}",
  markerDestinationId: "6523acd161bda4c9a6bdb9a7",
  wpUrl: "https://mydogcare.com/",
};
